import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
// import { Label } from 'reactstrap';

BarChart.propTypes = {
  heading: PropTypes.string,
  labels: PropTypes.array,
  data: PropTypes.array,
  height: PropTypes.number,
  legend: PropTypes.bool,
}
BarChart.defaultProps = {
  heading: '',
  labels: [],
  data: [],
  height: 70,
  legend: {
    display: false
  },
};



function BarChart(props) {
  let data = {
    labels: props.labels,
    // labels: ['ppppp'],
    datasets: [
      {
        labels: props.heading,
        fill: true,
        data: props.data,
        backgroundColor: [
          "#C62828", "#7B1FA2", "#303F9F", "#0097A7", "#00796B", "#558B2F"
        ],
        hoverBackgroundColor: [
          "#C62828", "#7B1FA2", "#303F9F", "#0097A7", "#00796B", "#558B2F"
        ]
      }]
  };

  let options = {
    scales: {
      xAxes: [{
        gridLines: {
          offsetGridLines: true
        },
        scaleLabel: {
          display: true,
          labelString: 'Student’s scores (in percentage)'
        }
      }],
      yAxes: [{
        gridLines: {
          offsetGridLines: true
        },
        scaleLabel: {
          display: true,
          labelString: 'Number of students'
        }
      }]
    },
    maintainAspectRatio: false	// Don't maintain w/h ratio
  }

  function barClick(e) {
    if (e[0] === undefined || e[0]._view.label === undefined) {
      console.log("test");
      // message.warning(‘no data’)
    } else {
      let label = e[0]._view.label;
      let value = e[0]._chart.chart.data.datasets[0].data[e[0]._index]
      console.log("LABEL:", label);
      console.log("VALUE:", value)
      props.onClick(label, value);
    }
    // console.log(e);
    // console.log(e[0]._view.label);//BAR LABEL
    // console.log(e[0]._index);
    // console.log(e[0]._chart.chart.data.datasets[0].data);
    // console.log(e[0]._chart.chart.data.datasets[0].data[e[0]._index]);//BAR VALUE

  }


  return (
   // <div>
      //<article className="canvas-container-normal-bar">
        <Bar
          data={data}
          height={props.height}
          //  onElementsClick={barClick}
          onElementsClick={(elems) => { barClick(elems) }}
          // getElementsAtEvent= { (elems) => {console.log(elems)}}
          legend={props.legend}
          options={options}
        />
     // </article>
   // </div>
  )
}

export default BarChart
